import { motion } from 'framer-motion';

interface Tab {
    id: string;
    label: string;
    icon: any;
}

interface PerfilTabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (id: string) => void;
}

export function PerfilTabs({ tabs, activeTab, onTabChange }: PerfilTabsProps) {
    return (
        <div className="sticky top-0 z-30 bg-neutral-950/80 backdrop-blur-xl border-b border-white/5 mt-8">
            <div className="container mx-auto px-4 md:px-6">
                <div className="flex items-center gap-1 overflow-x-auto no-scrollbar py-2">
                    {tabs.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => onTabChange(tab.id)}
                                className={`
                                    relative px-4 py-2.5 rounded-full flex items-center gap-2 text-sm font-medium transition-all whitespace-nowrap
                                    ${isActive ? 'text-white bg-white/10' : 'text-white/60 hover:text-white hover:bg-white/5'}
                                `}
                            >
                                <Icon size={18} className={isActive ? 'text-orange-500' : ''} />
                                {tab.label}
                                {isActive && (
                                    <motion.div
                                        layoutId="activeTab"
                                        className="absolute bottom-0 left-4 right-4 h-0.5 bg-orange-500 rounded-full hidden"
                                    />
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
